import { useSites } from '../../../context/SiteContext';
import { useReportVisits } from '../../../hooks/useReportVisits';
import { buildPages } from '../../../lib/analytics';
import { formatDuration, formatNumber, formatPercent } from '../../../lib/format';
import EmptyState from '../../../components/dashboard/EmptyState';
import PageHeader from '../../../components/dashboard/PageHeader';
import StatTable from '../../../components/dashboard/StatTable';
import ExportButton from '../../../components/dashboard/ExportButton';

export default function PagesPage() {
  const { currentSite } = useSites();
  const { ranged, range } = useReportVisits(currentSite);
  const pages = buildPages(ranged);

  if (!currentSite) {
    return <EmptyState title="先添加一个站点" desc="添加站点后可查看每个页面的浏览量、入口与出口。" />;
  }

  return (
    <div>
      <PageHeader
        title="受访页面"
        desc="找出最受欢迎的内容，同时看清入口页和离开页。"
        range={range}
        extra={
          <ExportButton
            filename={`${currentSite.domain}-pages.csv`}
            columns={['页面', '浏览量', '访客', '入口次数', '出口次数', '跳出率', '平均停留']}
            rows={pages.map((p) => [
              p.path,
              formatNumber(p.pv),
              formatNumber(p.uv),
              formatNumber(p.entry),
              formatNumber(p.exit),
              formatPercent(p.bounceRate),
              formatDuration(p.avgDuration),
            ])}
          />
        }
      />

      <div className="mt-6 rounded-lg border border-background-200 bg-background-50 overflow-hidden">
        <StatTable
          columns={['页面', '浏览量', '访客', '入口次数', '出口次数', '跳出率', '平均停留']}
          rows={pages.map((p) => [
            p.path,
            formatNumber(p.pv),
            formatNumber(p.uv),
            formatNumber(p.entry),
            formatNumber(p.exit),
            formatPercent(p.bounceRate),
            formatDuration(p.avgDuration),
          ])}
          empty="暂无页面数据"
        />
      </div>
    </div>
  );
}
